import * as Dialog from '@radix-ui/react-dialog';
import { Button } from 'components/ui/button';
import { X } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

interface AuthRequiredModalProps {
  isOpen: boolean;
  onOpenChange: (open: boolean) => void;
  type: 'save' | 'export';
}

export default function AuthRequiredModal({ isOpen, onOpenChange, type }: AuthRequiredModalProps) {
  const navigate = useNavigate();

  const content = {
    save: {
      title: "Save this logo?",
      description: "To proceed with saving this logo, please log in to your existing account or sign up to create a new one.",
    },
    export: {
      title: "Export this logo?",
      description: "To proceed with exporting this logo, please log in to your existing account or sign up to create a new one.",
    }
  };

  return (
    <Dialog.Root open={isOpen} onOpenChange={onOpenChange}>
      <Dialog.Portal>
        <Dialog.Overlay className="fixed inset-0 bg-black/50" />
        <Dialog.Content className="fixed bg-background text-text-primary left-[50%] top-[50%] translate-x-[-50%] translate-y-[-50%] rounded-lg p-6 shadow-lg w-[400px] max-w-[calc(100%-32px)]">
          <div className="flex flex-col gap-4">
            <div className="flex justify-between items-start">
              <Dialog.Title className="text-2xl font-bold">
                {content[type].title}
              </Dialog.Title>
              <Dialog.Close asChild>
                <button className="rounded-sm opacity-70 ring-offset-white transition-opacity hover:opacity-100 focus:outline-none focus:ring-2 focus:ring-slate-950 focus:ring-offset-2">
                  <X className="h-4 w-4" />
                  <span className="sr-only">Close</span>
                </button>
              </Dialog.Close>
            </div>
            
            <p className="text-sm">
              {content[type].description}
            </p>

            <div className="flex justify-end gap-2 mt-2">
              <Button
                onClick={() => {
                  onOpenChange(false);
                  navigate('/auth/login');
                }}
                variant="customSecondary"
                size="sm"
              >
                Log in
              </Button>
              <Button
                onClick={() => {
                  onOpenChange(false);
                  navigate('/auth/register');
                }}
                variant="customPrimary"
                size="sm"
              >
                Sign up
              </Button>
            </div>
          </div>
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  );
} 